import React from 'react';
import Img from '../Img';
import config from '../../config';

import styles from './rankingList.module.scss';

const { appHost } = config;

const GetRatedCta = () => {
    return (
        <div className={`${styles.rankItem} ${styles.getRatedCta}`}>
            <div className={`row ${styles.playerRow}`}>
                <div className={`col-1 ${styles.rankItemColumn} ${styles.rankColumn} text-teal`}>
                    ?
                </div>
                <div className="col-1 d-flex jcc aic">
                    <Img src="/img/default-profile-icon-120-x-120.svg" style={{ width: '40px', height: '40px' }} />
                </div>
                <div className={`col-5 col-sm-5 ${styles.rankItemColumn} jcfs`}>
                    <div className={`${styles.name} text-gray`}>
                        How do you compare?
                    </div>
                </div>
                <div className={`col-5 d-flex jce aic`}>
                    <span
                        className={`d-none d-md-inline-block`}
                    >See where you fit
                    </span>
                    <a href={`${appHost}/join`}>
                        <span
                            className={`btn btn-md btn-primary ml16 mr16 ${styles.getRatedButton}`}
                        >
                            Get Rated
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default GetRatedCta;
